<template>
    <div>
        <FullScreenModal header="header story" id="story" header-class="story-modal-header" body-class="story-modal-body" footer-class="story-modal-footer">
            <template #head>
                <div class="w-100 m-auto d-flex align-items-center" style="gap: 24px;">
                    <div class="p-t-16 p-t-small-10">
                        <span class="icon arrow-left size sm color primary" style="cursor: pointer;" @click="$bvModal.hide('story')" />
                    </div>
                    <span class="font f-s-20 l-h-28 f-w-800 f-s-small-16 l-h-small-24 f-w-small-700 p-t-24 p-b-12 p-t-small-16">Case Study</span>
                </div>
            </template>
            <template>
                <iframe :src="activeStory.pdf" class="h-100 w-100" frameborder="0" />
            </template>
            <template #foot>
                <div class="w-100 p-y-16 p-y-small-12 p-r-16 p-l-32 p-l-small-16 d-flex justify-content-between align-items-center flex-wrap" style="gap: 8px;">
                    <span class="font f-s-18 f-s-small-16 l-h-24 l-h-small-20 f-w-700 f-w-small-500 l-t-s-3">Discover how Peekage can help you exceed your business goals.</span>
                    <tuber is="nuxt-link" to="/contact?talk-to-an-expert=true" class="btn lg primary f-w-700 l-t-s-3 l-h-20" text-class="font f-s-16 l-h-20 f-w-700 l-t-s-3">
                        Talk to an expert
                    </tuber>
                </div>
            </template>
        </FullScreenModal>
        <container size="lg" class="p-x-small-16">
            <div class="p-t-64 p-b-40 p-b-small-0 p-t-small-24">
                <HeroV2 :content="head" />
            </div>
            <div class="stories p-y-24 p-y-small-16">
                <CustomerStoriesItem class="story" v-for="story in stories" :key="story.title">
                    <img :src="$image(story.image)" :alt="story.alt" class="w-100">
                    <div class="p-x-24 p-y-24 d-flex flex-column justify-content-between align-items-start story-info" style="gap: 24px; min-height: 314.5px;">
                        <div>
                            <div class="d-flex align-items-center" style="gap: 8px;">
                                <img :src="$image(story.brandLogoUri)" :alt="story.alt" width="48" height="48">
                                <div class="d-flex flex-column">
                                    <span class="font f-w-500 f-s-12 l-h-16 l-t-s-3 text-color secondary">Case study</span>
                                    <span class="font f-w-700 f-s-16 l-h-20 l-t-s-3">{{ story.brandName }}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column justify-content-between align-items-start flex-grow-1 m-t-8" style="gap: 32px;">
                                <span v-html="story.description" />
                            </div>
                        </div>
                        <div class="d-flex flex-column w-100" style="gap: 16px">
                            <div class="d-flex flex-wrap-reverse" style="gap: 10px;">
                                <span class="tag-chip font f-s-12 l-h-16 f-w-500 l-t-s-3 p-x-8 p-y-4" v-for="(tag, i) in story.tags" :key="i">
                                    {{ tag }}
                                </span>
                            </div>
                            <tuber v-b-modal="'story'" @click="activeStory = story" class="fit-content btn lg primary d-flex font f-s-16 l-h-24 f-w-700 w-100" style="letter-spacing: -0.3px;">
                                Read their story
                                <span class="icon arrow-right color onColor size sm m-l-4" />
                            </tuber>
                        </div>
                    </div>
                </CustomerStoriesItem>
            </div>
        </container>

        <container size="lg" class="m-t-96 m-t-small-60">
            <section class="p-l-small-0 p-r-small-0">
                <Banner
                    :btn-text="$device.mobile ? `Let's set a goal` : 'Book a demo'"
                >
                    <template #content>
                        <Heading
                            color="on-color"
                            class="f-w-600 f-s-small-28 l-h-small-36 text-center text-lg-left m-b-0"
                            tag="p"
                            size="x-lg"
                        >
                            Find out how peekage<br>can exceed your business goals
                        </Heading>
                    </template>
                </Banner>
            </section>
        </container>
    </div>
</template>

<script>
// import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import CustomerStoriesItem from '~/components/common/custormer-stories/CustomerStoriesItem';
import Banner from '~/components/common/banner';
import HeroV2 from '../components/common/heroV2';
import FullScreenModal from '../xerneas/src/components/modal/FullScreenModal';

export default {
    name: 'CaseStudies',
    components: {
        HeroV2,
        CustomerStoriesItem,
        Banner,
        FullScreenModal,
        // VuePdfEmbed,
    },
    layout: 'xerneas',
    data() {
        return {
            activeStory: '',
            pdfBase64: [],
            stories: [
                {
                    image: 'caseStudies/picture/abe.webp',
                    tags: [
                        'Digital Product Sampling',
                        'Increase Retail Velocity',
                    ],
                    description: '<span class="font f-w-800 f-s-28 l-h-36 l-t-s-75" style="color: #141414;">Abe’s Muffin increased retail velocity at Sprouts while generated <span style="color: #0E47C0;">over 40%</span> Repurchase Rate</span>',
                    uri: '/',
                    brandName: "Abe's muffin",
                    brandLogoUri: 'caseStudies/brandsLogo/abe-logo.webp',
                    alt: "Abe's muffin",
                    pdf: 'https://peekagecdn.blob.core.windows.net/nightly/127564bf-686a-4d81-bdda-ab766addc988.pdf#view=FitH',
                },
                {
                    image: 'caseStudies/picture/wise.webp',
                    tags: [
                        'In-Home Usage Testing',
                        'Sensory Testing',
                    ],
                    description: '<span class="font f-w-800 f-s-28 l-h-36 l-t-s-75" style="color: #141414;">Wise Snacks Cuts Research Costs <span style="color: #F78834;">by 70% </span>and Speeds Up IHUT 4X</span>',
                    uri: '/',
                    brandName: 'Wise Snacks',
                    brandLogoUri: 'caseStudies/brandsLogo/wise-logo.webp',
                    alt: 'wise snacks',
                    pdf: 'https://peekagecdn.blob.core.windows.net/nightly/cfc23dc6-85af-47c5-8f76-ad6be0e45669.pdf#view=FitH',
                },
                {
                    image: 'caseStudies/picture/uresta.webp',
                    tags: [
                        'Concept Testing',
                        'Buyer Persona Study',
                    ],
                    description: '<span class="font f-w-800 f-s-28 l-h-36 l-t-s-75" style="color: #141414;">Uresta <span style="color: #009B8E;">Uncovers Premium Pricing</span> Opportunities with Concept Testing</span>',
                    uri: '/',
                    brandName: 'Uresta',
                    brandLogoUri: 'caseStudies/brandsLogo/uresta-logo.png',
                    alt: 'Uresta',
                    pdf: 'https://peekagecdn.blob.core.windows.net/nightly/385cad2a-73d4-47bb-b8cd-9ab3fbd78fc0.pdf#view=FitH',
                },
            ],
            head: {
                imgPath: 'caseStudies/case-head.png',
                subject: 'Real Results with Peekage',
                title: 'Our Customer Stories',
                text: 'Discover how Peekage helps brands grow through actionable consumer insights. From product development to retail success, see the measurable results we’ve delivered.',
            },
            showStory: false,
        };
    },
    mounted() {
        // this.syncHeights();
        window.addEventListener('resize', this.syncHeights);
        this.syncHeights();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.syncHeights);
    },
    methods: {
        handleDownload(e) {
            console.log(e, 'downloaded');
        },
        syncHeights() {
            // this.$nextTick(() => {
            const storyElements = document.querySelectorAll('.story-info');
            let maxHeight = 0;

            // Reset heights to auto to recalculate
            storyElements.forEach(el => {
                el.style.height = 'auto';
            });
            if (!storyElements.length) { return; }
            // Calculate the maximum height
            storyElements.forEach(el => {
                const height = el.offsetHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
            // Set all elements to the maximum height
            storyElements.forEach(el => {
                if (!el) { return; }
                el.style.height = `${maxHeight}px`;
            });
            // });
        },
    },
};
</script>

<style lang="scss">
.story-modal{
    &-header {
        padding: 30px;
    }
}
.stories {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 16px;
    .story{
        border-radius: 20px;
        border: 1px solid var(--Color-Nuetral-100, #E3E3E3);
        background: var(--Color-White, #FFF);
                .tag-chip{
                    border-radius: 9999px;
                    border: 1px solid var(--Color-Nuetral-100, #E3E3E3);
                    background: var(--Color-Nuetral-50, #F4F4F4);
                }

    }
}

@media (max-width: 768px) {
    .stories {
        grid-template-columns: 100%;
    }
}
</style>
